import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { MergeTagStore, MergeTagState } from './merge-tag.store';

@Injectable({ providedIn: 'root' })
export class MergeTagQuery extends QueryEntity<MergeTagState> {
	constructor(protected override store: MergeTagStore) {
		super(store);
	}

}
